<template>
  <div class="footer">
    <div class="footer__inner">
      <p :class="['footer__txt', { 'is-map': isMap() }]">
        Copyright ©BALANCe All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    isMap() {
      return this.$route.path == "/map";
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 60px;

  &__txt {
    font-size: 10px;
    color: #8c8c8c;
    font-weight: 500;
    line-height: 1;

    &.is-map {
      position: absolute;
      left: 82px;
      bottom: 30px;

      @include max(768) {
        left: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Footer/_index.vue